module.exports = __webpack_public_path__ + "static/media/Headshot.1319d4f8.jpg";